import { WorkboardTask } from 'api/models/WorkboardTask';

export const TASK_STATUS_OPTIONS = [
  { value: WorkboardTask.status.PENDING, label: 'Pending' },
  { value: WorkboardTask.status.IN_PROGRESS, label: 'In Progress' },
  { value: WorkboardTask.status.COMPLETED, label: 'Completed' },
  { value: WorkboardTask.status.CANCELLED, label: 'Cancelled' },
] as const;

export const TASK_STATUS_TRACKER_OPTIONS = TASK_STATUS_OPTIONS.map(option => ({
  id: option.value,
  label: option.label,
}));

export const RECURRENCE_FREQUENCY_OPTIONS = [
  { value: WorkboardTask.recurrence_frequency.NONE, label: 'Does not repeat' },
  { value: WorkboardTask.recurrence_frequency.DAILY, label: 'Daily' },
  { value: WorkboardTask.recurrence_frequency.WEEKLY, label: 'Weekly' },
  { value: WorkboardTask.recurrence_frequency.MONTHLY, label: 'Monthly' },
  { value: WorkboardTask.recurrence_frequency.YEARLY, label: 'Yearly' },
] as const;

export const RECURRENCE_WEEKDAY_OPTIONS = [
  { value: 'MO', label: 'Mon' },
  { value: 'TU', label: 'Tue' },
  { value: 'WE', label: 'Wed' },
  { value: 'TH', label: 'Thu' },
  { value: 'FR', label: 'Fri' },
  { value: 'SA', label: 'Sat' },
  { value: 'SU', label: 'Sun' },
] as const;

export const RECURRENCE_SETPOS_OPTIONS = [
  { value: 1, label: 'First' },
  { value: 2, label: 'Second' },
  { value: 3, label: 'Third' },
  { value: 4, label: 'Fourth' },
  { value: 5, label: 'Fifth' },
  { value: -1, label: 'Last' },
] as const;

export type RecurrenceEndMode = 'none' | 'date' | 'count';
